<template>
  <div>
    <base-modal size="max-w-3xl" :showing="visible" @close="$emit('close')" @opened="onOpened">
      <base-card title="Detail Perubahan Data" description="Berdasarkan data yang telah dibuat" :with-style="false">
        <div class="border-t pt-5">
          <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:pb-6 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Kode Mitra Usaha</dt>
              <dd class="mt-1 text-sm text-gray-700">
                <span class="font-bold text-gray-900">
                  {{ officeDataChange.data.attributes.office_code }}
                </span>
                /
                <span>
                  {{ officeDataChange.data.attributes.office_temp_code }}
                </span>
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Nama Mitra Usaha</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.office_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">No. KTP</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.ktp_number }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">No. Telp</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.cellphone }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">No. Rekening</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.bank_account_number }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Nama Rekening</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.bank_account_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Nama Bank</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.bank_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Cabang Bank</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.bank_branch_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">No. NPWP</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.npwp_number }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Nama NPWP</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.npwp_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Alamat NPWP</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.npwp_address }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Alamat Lanjutan NPWP</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.npwp_address2 }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Kota NPWP</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.npwp_city }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Status</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.marital_status ? 'Kawin' : 'Belum Kawin' }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Istri/Suami</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.spouse_job_status ? 'Bekerja' : 'Tidak Bekerja' }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="text-xs text-gray-700">Jumlah Anak + Tanggungan</dt>
              <dd class="mt-1 text-sm text-gray-700">
                {{ officeDataChange.data.attributes.children }}
              </dd>
            </div>
          </dl>
        </div>
      </base-card>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import { requestMixin } from '@/mixins/request/request';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
  },
  props: {
    visible: Boolean,
    id: String,
  },
  emits: ['close'],
  data() {
    return {
      loading: false,
      officeDataChange: {
        data: {
          attributes: {
            code: null,
          },
        },
      },
    };
  },
  methods: {
    async onOpened() {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/office-data-changes/${this.id}`
      );

      if (!err) {
        this.officeDataChange = res;
      }

      this.loading = false;
    },
  },
};
</script>
